import { Injectable } from '@angular/core';

@Injectable()
export class AdminService {

  constructor() { }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/admin.service.ts